import {
  Avatar,
  Card,
  Paragraph,
  Col,
  Row,
} from "@george-labs.com/design-system"
import dayjs from "../../utils/dayjs"
import { useNotification } from "../../app/hooks"

interface INotificationItemProps {
  clamped: boolean
  id: string
}

const NotificationItem = ({ clamped, id }: INotificationItemProps) => {
  const notification = useNotification(id)

  if (!notification) return null

  const today = dayjs(notification.creationDate)?.isSame(dayjs(), "day")

  const dateContent = (
    <Paragraph small className="align-top">
      {today
        ? dayjs(notification.creationDate).format("HH:mm")
        : dayjs(notification.creationDate).format("YYYY.MM.DD")}
    </Paragraph>
  )

  return (
    <Card className="p-0 m-0">
      <Row className="px-2">
        <Col xs={12} md={2} className="p-0 m-0 d-xs-block d-md-none">
          {dateContent}
        </Col>
        <Col md={2} lg={1} className="p-0 d-none text-center d-md-block">
          <Avatar icon={Avatar.ICON.MONEY} color={Avatar.COLOR.UI_BLUE} />
        </Col>
        <Col xs={12} md={8} lg={9}>
          <Row>
            <Paragraph small>{notification.messageSubject}</Paragraph>
          </Row>
          <Row>
            <Paragraph
              className={[
                clamped ? "clamp" : "",
                notification.read ? "" : "font-weight-bold",
              ].join(" ")}
            >
              {clamped
                ? notification.messageText.replaceAll(/(\r\n|\n|\r)/gm, " ")
                : notification.messageText}
            </Paragraph>
          </Row>
        </Col>
        <Col xs={12} md={2} className="p-0 m-0 text-center d-none d-md-block">
          {dateContent}
        </Col>
      </Row>
    </Card>
  )
}

export default NotificationItem
